import { render } from "./jiancedetail.vue?vue&type=template&id=41a6b444&scoped=true&ts=true"
import script from "./jiancedetail.vue?vue&type=script&lang=ts"
export * from "./jiancedetail.vue?vue&type=script&lang=ts"

import "./jiancedetail.vue?vue&type=style&index=0&id=41a6b444&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a6b444"]])

export default __exports__